/**
 * Codmonボタンディレクティブ
 *
 * @description
 * このディレクティブは、カスタマイズ可能なボタンを提供します。バリアント、サイズ、アイコン、クリックイベントなどを設定可能です。
 *
 * @example
 * // カスタムバリアントやサイズ、アイコン付きボタン
 * <codmon-button
 *   variant="primary"
 *   size="large"
 *   on-click="addFunction()"
 *   leading-icon-name="checkmark-outline">
 *   カスタム内容
 * </codmon-button>
 *
 * @example
 * // 任意の内容を含むボタン
 * <codmon-button>任意の内容</codmon-button>
 *
 * @example
 * // 新プライマリカラーを使用
 * <codmon-button
 *   variant="primary"
 *   is-new-primary-color="true"
 *   on-click="handleClick()">
 *   保存
 * </codmon-button>
 *
 * @property {string} variant - ボタンの種類を指定 (例: primary, secondary, text, neutral, caution, caution-text, danger)
 * @property {string} size - ボタンのサイズを指定 (例: xsmall, small, medium, large)
 * @property {boolean} [ng-disabled=false] - ボタンの無効化状態を指定
 * @property {Function} on-click - ボタンのクリックイベントを指定
 * @property {string} [leading-icon-name] - ボタン内の先頭アイコンを指定
 * @property {string} [trailing-icon-name] - ボタン内の末尾アイコンを指定
 * @property {string} [is-new-primary-color="false"] - 新プライマリカラー（#017DBC）を使用するか（デフォルト: false = 旧CoDMON Blue #01A2C1を使用）
 * @property {string} [type="button"] - ボタンのtype属性を指定 (例: button, submit, reset)
 */
angular.module('inspinia').directive('codmonButton', () => {
  return {
    restrict: 'E',
    scope: {
      variant: '@',
      ngDisabled: '=?',
      size: '@',
      type: '@',
      onClick: '&',
      leadingIconName: '@',
      trailingIconName: '@',
      isNewPrimaryColor: '=?',
    },
    transclude: true,
    templateUrl: `/manage/src/view/directive/codmon-ui/codmon_button.html?${new Date().getTime()}`,
    link($scope) {
      // デフォルト値の設定
      $scope.ngDisabled = !!$scope.ngDisabled;
      $scope.isNewPrimaryColor = !!$scope.isNewPrimaryColor;

      const buttonTypes = ['button', 'submit', 'reset'];
      $scope.type = buttonTypes.includes($scope.type) ? $scope.type : 'button';

      const buttonSizes = ['xsmall', 'small', 'medium', 'large'];
      $scope.size = buttonSizes.includes($scope.size) ? $scope.size : 'medium';

      const buttonVariants = ['primary', 'secondary', 'text', 'neutral', 'caution', 'caution-text', 'danger'];
      $scope.variant = buttonVariants.includes($scope.variant) ? $scope.variant : 'primary';

      // クリックイベント
      $scope.onClickCodmonButton = () => {
        if (!$scope.ngDisabled && $scope.onClick) $scope.onClick();
      };

      // CSSクラス名を返す
      $scope.codmonButtonClasses = () => {
        const buttonClasses = {
          'codmon-button': true,
        };
        if ($scope.variant) {
          buttonClasses[`codmon-button--${$scope.variant}`] = true;
        }
        if ($scope.leadingIconName) {
          buttonClasses['codmon-button--leadingIcon'] = true;
        }
        if ($scope.size) {
          buttonClasses[`codmon-button--${$scope.size}`] = true;
        }
        if ($scope.ngDisabled) {
          buttonClasses['codmon-button--disabled'] = true;
        }
        // 新カラー使用時のクラスを追加
        if ($scope.isNewPrimaryColor) {
          buttonClasses['codmon-button--new-primary-color'] = true;
        }
        return buttonClasses;
      };

      // アイコンクラス
      $scope.codmonIconClasses = () => {
        const iconClasses = ['codmon-icon'];
        if ($scope.size) {
          iconClasses.push(`codmon-icon--${$scope.size}`);
        }
        return iconClasses;
      };

      // アイコンサイズを返す
      $scope.codmonIconSize = () => {
        switch ($scope.size) {
          case 'xsmall':
            return { width: '16', height: '16' };
          case 'small':
            return { width: '16', height: '16' };
          case 'large':
            return { width: '20', height: '20' };
          case 'medium':
          default:
            return { width: '20', height: '20' };
        }
      };
    },
  };
});
